import { useI18N, useLocalStorageState } from "@sundae/react-hooks";
import { Button, Tooltip } from "@sundae/ui-toolkit";
import { useQuery } from "@tanstack/react-query";
import { LOCAL_STORAGE_APP_VERSION } from "../../constants/localStorage.constants";
import { IBuildInfo } from "../../types/AppConfig";

const UpdateVersionButton = () => {
  const { t } = useI18N("header");
  const currentAppVersion = window.__BUILD_CONFIG.buildId as string;
  const [appVersion, setAppVersion] = useLocalStorageState(LOCAL_STORAGE_APP_VERSION);
  const siteUrl = window.__APP_CONFIG.siteUrl;
  const { data } = useQuery<IBuildInfo>(["latest"], () =>
    fetch(`${siteUrl}/latest.json?v=${new Date().getTime()}`).then(async (res) => res.json())
  );

  const refreshPage = () => {
    if (data && appVersion !== data.buildId) {
      setAppVersion(data.buildId);
      window.location.href = `/${data.buildId}.html`;
    }
  };

  if (!data || currentAppVersion === data?.buildId) return null;

  return (
    <Tooltip
      tooltipLabel={t("appVersion.tooltip", {
        context: appVersion === data.buildId ? "manualRefresh" : "refresh",
      })}
      trigger={
        <Button className="h-8 px-4" onClick={refreshPage} size="custom" variant="error">
          {t("update", { ns: "common" })}
        </Button>
      }
    />
  );
};

export default UpdateVersionButton;
